import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  BillingInfoID: null,
  BillingFirstName: null,
  BillingLastName: null,
  BillingAddressStreet1: null,
  BillingAddressStreet2: null,
  BillingAddressCity: null,
  BillingAddressRegion: null,
  BillingAddressPostalCode: null,
  BillingAddressCountry: null,
  PaymentMethodObject: null,
  PaymentMethodCardType: null,
  PaymentMethodLastFour: null,
  PaymentMethodExpMonth: null,
  PaymentMethodExpYear: null,
};

export const billingSlice = createSlice({
  name: 'subscription',
  initialState,
  reducers: {
    setBilling: (state, action) => {
      state.BillingInfoID = action.payload.BillingInfoID;
      state.BillingFirstName = action.payload.BillingFirstName;
      state.BillingLastName = action.payload.BillingLastName;
      state.BillingAddressStreet1 = action.payload.BillingAddressStreet1;
      state.BillingAddressStreet2 = action.payload.BillingAddressStreet2;
      state.BillingAddressCity = action.payload.BillingAddressCity;
      state.BillingAddressRegion = action.payload.BillingAddressRegion;
      state.BillingAddressPostalCode = action.payload.BillingAddressPostalCode;
      state.BillingAddressCountry = action.payload.BillingAddressCountry;
      state.BillingInfoValid = action.payload.BillingInfoValid;
      state.PaymentMethodObject = action.payload.PaymentMethodObject;
      state.PaymentMethodCardType = action.payload.PaymentMethodCardType;
      state.PaymentMethodLastFour = action.payload.PaymentMethodLastFour;
      state.PaymentMethodExpMonth = action.payload.PaymentMethodExpMonth;
      state.PaymentMethodExpYear = action.payload.PaymentMethodExpYear;
    },
    resetBilling: () => initialState,
  },
});

export const { setBilling, resetBilling } = billingSlice.actions;

export default billingSlice.reducer;

// Selectors
export const selectBilling = (state) => state.billing;
